function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3417 21.8944C14.4988 22.3578 13.4174 21.7988 13.4174 20.8868V9.90554C13.4174 8.98615 14.4988 8.43451 15.3417 8.89053L25.2971 14.3775C26.1241 14.8335 26.1241 15.9441 25.2971 16.4001L15.3417 21.8944ZM15.9619 11.9723V18.8126L22.1642 15.3851L15.9619 11.9723Z",
  fill: "url(#paint23_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5622 29.5559C24.9653 30.6734 14.3617 30.6734 6.76477 29.5559C3.72753 29.1074 1.33293 26.7355 0.812693 23.6566C-0.158919 17.9398 -0.158919 12.8464 0.812693 7.13716C1.33293 4.05828 3.72753 1.68641 6.76477 1.23788C10.5671 0.675323 15.1268 0.394043 19.6864 0.394043C24.2308 0.394043 28.7752 0.675323 32.5699 1.23788C35.6071 1.68641 38.0017 4.05828 38.5219 7.13716C39.4936 12.854 39.4936 17.9474 38.5219 23.6566C37.9941 26.7431 35.5995 29.115 32.5622 29.5559ZM36.1044 7.54767C35.7601 5.51029 34.1918 3.94425 32.2026 3.65537C24.8276 2.56826 14.5147 2.56826 7.11669 3.65537C5.12757 3.95185 3.55922 5.51029 3.21495 7.54767C2.28159 13.0516 2.28159 17.7498 3.21495 23.2613C3.55922 25.2987 5.12757 26.8647 7.11669 27.1536C10.8195 27.701 15.2415 27.9671 19.6635 27.9671C24.0855 27.9671 28.5151 27.6934 32.2026 27.1536C34.1918 26.8571 35.7601 25.2987 36.1044 23.2613C37.0454 17.7498 37.0454 13.0516 36.1044 7.54767Z",
  fill: "url(#paint24_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: 19.6674,
  y1: 22.0607,
  x2: 19.6674,
  y2: 8.7274,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear",
  x1: 19.6673,
  y1: 30.394,
  x2: 19.6673,
  y2: 0.394043,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})));

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1fbecd1b.svg";
export { ForwardRef as ReactComponent };